export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13096.1c322a50.jpg";